"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _host = require("../../host");
var _utils = require("../../../utils/utils");
class HostServicePE extends _host.HostService {
  constructor(_ref) {
    let {
      hostMarketingId,
      hostAddToCartCallback,
      config,
      openGuidedSellingModal
    } = _ref;
    super({
      hostMarketingId,
      hostAddToCartCallback,
      config,
      openGuidedSellingModal
    });
    this.PeruLocalStorageAttributeMap = {
      handsetOnly: {
        journey: 'equipment'
      }
    };
    this.basketConfig = config === null || config === void 0 ? void 0 : config.basket;
  }
  getMarketingId() {
    var _window$guidedSelling;
    if (typeof ((_window$guidedSelling = window.guidedSelling) === null || _window$guidedSelling === void 0 ? void 0 : _window$guidedSelling.marketingId) !== 'function') {
      return super.getMarketingId();
    }
    return window.guidedSelling.marketingId();
  }
  redirect(url, params) {
    if (!url) return null;
    return setTimeout(() => {
      try {
        window.open(`${url}?${(0, _utils.objectToQueryString)(params)}`, this.basketConfig.openInNewTab ? '_blank' : '_self');
      } catch (error) {
        console.error('Unable to open product page');
      }
    }, 2);
  }
  async addToCart(_ref2) {
    var _this$basketConfig, _this$basketConfig2, _this$PeruLocalStorag;
    let {
      handsetProductId,
      planProductId,
      appMetadata
    } = _ref2;
    const isPlansOnlyFlow = planProductId && !handsetProductId;
    const baseUrl = isPlansOnlyFlow ? (_this$basketConfig = this.basketConfig) === null || _this$basketConfig === void 0 ? void 0 : _this$basketConfig.plansApiURL : (_this$basketConfig2 = this.basketConfig) === null || _this$basketConfig2 === void 0 ? void 0 : _this$basketConfig2.SOPApiURL;
    // Extract flags from app metadata
    const {
      flags: {
        isCustomer,
        planPortLine
      } = {}
    } = appMetadata;
    // Determine the flow based on product IDs
    let flow;
    if (planProductId && handsetProductId) flow = 'bothFlow';else if (handsetProductId) flow = 'handsetOnly';else if (planProductId) flow = 'planOnly';

    // Modalidad mappings for customers
    const customerModalidadMap = {
      bothFlow: 'Activacion de Linea',
      // planOnly: planPortLine ? 'linea-adicional-portabilidad' : 'linea-adicional-linea-nueva',
      planOnly: planPortLine ? 'migra-postpago' : 'linea-nueva-postpago',
      handsetOnly: 'Renovacion'
    };

    // Modalidad mappings for non-customers
    const nonCustomerModalidadMap = {
      bothFlow: 'Portabilidad',
      planOnly: planPortLine ? 'migra-postpago' : 'linea-nueva-postpago',
      handsetOnly: 'Libres'
    };
    let queryParams = {
      modalidad: isCustomer ? customerModalidadMap[flow] : nonCustomerModalidadMap[flow],
      planId: planProductId === null || planProductId === void 0 ? void 0 : planProductId.replace(/-PLANS(\d+)/, ''),
      poId: handsetProductId
    };
    if (flow !== 'planOnly') {
      queryParams = {
        ...queryParams,
        flow: 'equipos',
        oferta: 'regular',
        cuota: 0
      };
    }
    const preExistingObject = JSON.parse(localStorage.getItem('pp.cache.ppGTMInfo '));
    localStorage.setItem('pp.cache.ppGTMInfo ', JSON.stringify({
      ...(preExistingObject !== null && preExistingObject !== void 0 ? preExistingObject : {}),
      ...((_this$PeruLocalStorag = this.PeruLocalStorageAttributeMap[flow]) !== null && _this$PeruLocalStorag !== void 0 ? _this$PeruLocalStorag : {})
    }));
    this.redirect(baseUrl, queryParams);
    return super.addToCart({
      handsetProductId,
      planProductId
    });
  }
}
var _default = HostServicePE;
exports.default = _default;